import Immutable from 'immutable';

// This is copied from https://github.com/jurassix/react-immutable-render-mixin
// It's copied into this repo so it's easier to use a debuggable version to find
// what's different about the props/state. This is definitely a bit of a hack but
// it works for now.

const is = Immutable.is.bind(Immutable);

export function shallowEqualImmutable(objA, objB, debug) {
  if (objA === objB || is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null
      || typeof objB !== 'object' || objB === null) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (let i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      // console.log('Different', keysA[i]);
      return false;
    }
  }

  return true;
}

export function shouldComponentUpdate(nextProps, nextState) {
  // @ts-ignore
  return !shallowEqualImmutable(this.props, nextProps) || !shallowEqualImmutable(this.state, nextState);
}

export { is };

export function diff(a, b) {
  return !is(a, b);
}
